import { FunctionComponent, useMemo } from "react";
import S from "./styled";

type OwnProps = {
  size?: number;
  color?: [number, number, number];
  parts?: number;
  className?: string;
};
type Props = OwnProps;

const Flame: FunctionComponent<Props> = ({ size = 240, color = [255, 80, 0], parts = 2, className }) => {
  const { width, height, partsSize } = useMemo(() => {
    return { width: size, height: size * 1.2, partsSize: `${size * 1.1}px` };
  }, [size]);

  const rgbColor = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
  const rgbColorT = `rgba(${color[0]}, ${color[1]}, ${color[2]}, 0)`;

  return (
    <S.Container style={{ width: `${width}px`, height: `${height}px` }} className={className}>
      {[...Array(parts)].map((index) => (
        <S.Particle partsSize={partsSize} color={rgbColor} colorT={rgbColorT} parts={parts} key={index}></S.Particle>
      ))}
    </S.Container>
  );
};

export default Flame;
